import { render, staticRenderFns } from "./PermissionSubmit.vue?vue&type=template&id=ad476a7e"
import script from "./PermissionSubmit.vue?vue&type=script&lang=js"
export * from "./PermissionSubmit.vue?vue&type=script&lang=js"
import style0 from "./PermissionSubmit.vue?vue&type=style&index=0&id=ad476a7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports